import React from "react";

import DesktopProjectPage from "components/Project/DesktopProjectPage";
import MobileProjectPage from "./MobileProjectPage";
import ProjectPage from "components/Project/ProjectPage";

import sessionStorageService from "services/sessionStorageService";
import localize from "lang/localize";

class LosDesafiosProjectPage extends ProjectPage {
  render() {
    const IS_640_DESKTOP_PROJECT =
      sessionStorageService.getItem("640_desktop_project") === "true"
        ? true
        : false;
    const FLAVOR_TEXT_ARR = [
      localize("showcase_suggestion_1", this.props.language),
      localize("showcase_suggestion_2", this.props.language),
      localize("showcase_suggestion_3", this.props.language)
    ];

    return (
      <div className="project container nopadding">
        {this.props.showPopup && this.renderPopupAlertDialog()}
        {this.props.showShareGameDialog && this.renderShareGameDialog()}
        {this.props.showTopicsListDialog && this.renderTopicsListDialog()}
        <div
          className={
            "desktop-project innerblock verticalpadding horizontalpadding pure-g bottompadding-floating" +
            (IS_640_DESKTOP_PROJECT ? " hide-below-md-640" : " hide-below-md")
          }
        >
          {/* Render desktop Project page here */}
          <DesktopProjectPage
            categoryId={this.props.id}
            categories={this.props.categories}
            topics={this.props.topics}
            more={this.props.more}
            randomNumber={this.state.randomNumber}
            flavorTextArr={FLAVOR_TEXT_ARR}
            showcaseProject={this.props.showcaseProject}
            addAnchors={this.addAnchors}
            handleMore={this.props.handleMore}
            renderTopics={this.renderTopics}
            language={this.props.language}
          />
        </div>
        <div
          className={
            "mobile-project" +
            (IS_640_DESKTOP_PROJECT ? " hide-from-md-640" : " hide-from-md")
          }
        >
          {/* Render mobile Project page here */}
          <MobileProjectPage
            project={this.props.project}
            projectId={this.props.projectId}
            projectImage={this.props.projectImage}
            buttons={this.props.buttons}
            topics={this.props.topics}
            user={this.props.user}
            team={this.props.team}
            categoryId={this.props.id}
            notifications={this.props.notifications}
            inboxUnread={this.props.inboxUnread}
            more={this.props.more}
            randomNumber={this.state.randomNumber}
            flavorTextArr={FLAVOR_TEXT_ARR}
            showcaseProject={this.props.showcaseProject}
            addAnchors={this.addAnchors}
            handleMore={this.props.handleMore}
            handleOpenShareGameDialog={this.props.handleOpenShareGameDialog}
            handleOpenTopicsListDialog={this.props.handleOpenTopicsListDialog}
            renderTopics={this.renderTopics}
            language={this.props.language}
          />
        </div>
      </div>
    );
  }
}

export default LosDesafiosProjectPage;
